import { render, staticRenderFns } from "./MapData.vue?vue&type=template&id=f2caabe2"
import script from "./MapData.vue?vue&type=script&lang=js"
export * from "./MapData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports